import { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../auth/useAuth'
import { homePathFor, SEM_ACESSO_PATH } from '../router/paths'
import type { AreaKey } from './areas'
import { areasNavegaveis, lembrarArea, primeiraTelaDaArea } from './acesso'

/** Portão de uma área inteira: sem a área, a URL digitada à mão volta para a home,
 *  e a home nunca é esta área, então não há laço.
 *
 *  Camada de INTERFACE, como o PermissionGate: quem recusa de verdade é o servidor,
 *  que filtra as permissões pela área concedida. Ver docs/areas/04-entrada-e-autorizacao.md. */
export function AreaGate({ area }: { area: AreaKey }) {
  const { user } = useAuth()
  const permitida = areasNavegaveis(user).includes(area)

  useEffect(() => {
    if (permitida) lembrarArea(area)
  }, [area, permitida])

  if (!permitida) return <Navigate to={homePathFor(user)} replace />
  return <Outlet />
}

/** A raiz da área, como `/logistica`, leva à primeira tela que a pessoa alcança. */
export function InicioDaArea({ area }: { area: AreaKey }) {
  const { user } = useAuth()
  const { search } = useLocation()
  const destino = primeiraTelaDaArea(area, user)
  return <Navigate to={destino ? `${destino}${search}` : SEM_ACESSO_PATH} replace />
}
